<template>
<div class="chapter">
<div class="inner_page">
<h2 class="block_114" id="id_Toc146554278">Prologue</h2>
<p class="block_10"> </p>
<p class="block_10"> </p>
<p class="block_4">Yesterday I was clever, so I wanted to change the world.</p>
<p class="block_4">Today I am wise, so I am changing myself.</p>
<p class="block_2">Rumi</p>
<p class="block_4">Isn’t it nice to think that tomorrow is a new day</p>
<p class="block_4">with no mistakes in it yet?</p>
<p class="block_2">L. M. Montgomery</p>
<p class="block_4">Life can only be understood backwards;</p>
<p class="block_4">but it must be lived forwards.</p>
<p class="block_2">Soren Kierkegaard</p>
<p class="block_15"> </p>
<p class="block_16">We all have those times in our lives, pushed to the breaking point, absolutely pure hell to live through. In the here and now, looking back, you come to understand that, as a snag in the tapestry of your life, if you were to tug on it, everything that you’ve come to be, to know, to accept, would simply unravel into nothing.</p>
<p class="block_17">Holding my newborn daughter, the new father, the inexperience in me wants to know what I could possibly have to offer, in terms of wisdom, of guidance, of advice to a young person embarking on life. Nevertheless, I realize there is one thing I can do.</p>
<p class="block_18">Ashley, I promise to always do my best, to be the father you deserve. There will be mistakes—I’m going to screw up more than you will ever know. But hear this…I will love you with all of my heart for every moment that I live.</p>
<p class="block_12" id="calibre_pb_7"> </p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// index_split_004.vue?71125eaf